module.exports = __webpack_public_path__ + "img/flecha-arriba.a96c406e.svg";